module.exports = __webpack_public_path__ + "img/student_boy.24cb660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/student_boy.png
// module id = wmSf
// module chunks = 1